import React from 'react';

function PayoutDefaultTH({ className, children }) {
	return (
		<th className={className}>
			{children}
		</th>
	);
}

export default PayoutDefaultTH;


// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/payouts/components/table/components/payout-head/components/payout-default-th.js